const nutriniumLogoSrc = new URL("../assets/branding/developed_by.png", import.meta.url).href;

export type AppFooterVariant = "portal" | "shell";

const CL: Record<
  AppFooterVariant,
  {
    root: string;
    inner: string;
    copy: string;
    dev: string;
    devLabel: string;
    devLink: string;
    devLogo: string;
    devName: string;
  }
> = {
  portal: {
    root: "portal-login__footer",
    inner: "portal-login__footer-inner",
    copy: "portal-login__footer-copy",
    dev: "portal-login__footer-dev",
    devLabel: "portal-login__footer-dev-label",
    devLink: "portal-login__footer-dev-link",
    devLogo: "portal-login__footer-dev-logo",
    devName: "portal-login__footer-dev-name",
  },
  shell: {
    root: "app-footer",
    inner: "app-footer__inner",
    copy: "app-footer__copy",
    dev: "app-footer__dev",
    devLabel: "app-footer__dev-label",
    devLink: "app-footer__dev-link",
    devLogo: "app-footer__dev-logo",
    devName: "app-footer__dev-name",
  },
};

/** Shared copyright + Nutrinium credit (login page + HO console shell). */
export function AppFooter({ variant = "shell" }: { variant?: AppFooterVariant }) {
  const c = CL[variant];
  const year = new Date().getFullYear();

  return (
    <footer className={c.root}>
      <div className={c.inner}>
        <p className={c.copy}>© {year} Indiramma Indlu. All rights reserved.</p>
        <div className={c.dev}>
          <span className={c.devLabel}>Designed and Developed by:</span>
          <a
            href="https://nutrinium.in/"
            target="_blank"
            rel="noopener noreferrer"
            className={c.devLink}
          >
            <img
              src={nutriniumLogoSrc}
              alt=""
              className={c.devLogo}
              loading="lazy"
              decoding="async"
            />
            <span className={c.devName}>Nutrinium Technologies Pvt Ltd</span>
          </a>
        </div>
      </div>
    </footer>
  );
}
